import { makeStyles } from 'tss-react/mui';

const ROW_HEIGHT = 46;
const COLLAPSED_ROW_HEIGHT = 36;
export const LEADING_SLOT_SIZE = 24;

interface ResultRowBaseStyleParams {
  isActive?: boolean;
  isDisabled?: boolean;
  isSingleLine: boolean;
}

export const useResultRowBaseStyles = makeStyles<ResultRowBaseStyleParams>()(
  (theme, { isActive, isDisabled, isSingleLine }) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      boxSizing: 'border-box',
      minHeight: isSingleLine ? COLLAPSED_ROW_HEIGHT : ROW_HEIGHT,
      padding: theme.spacing(0.75, 1),
      cursor: isDisabled ? 'default' : 'pointer',
      borderRadius: `${theme.shape.borderRadiusLg}px`,
      backgroundColor: isActive ? theme.palette.action.hover : 'transparent',
      '&:hover': {
        backgroundColor: isDisabled ? 'transparent' : theme.palette.action.hover,
      },
      '[data-keyboard-nav="true"] &:hover': {
        backgroundColor: isActive && !isDisabled ? theme.palette.action.hover : 'transparent',
      },
      '& [data-row-actions]': {
        opacity: isActive ? 1 : 0,
        transition: theme.transitions.create('opacity'),
      },
      '&:hover [data-row-actions]': { opacity: 1 },
      '&:focus-within [data-row-actions]': { opacity: 1 },
      '& [data-row-actions][data-row-actions-persistent]': { opacity: 1 },
      '@media (hover: none)': {
        '& [data-row-actions]': { opacity: 1 },
      },
    },
    contentStack: {
      alignItems: 'center',
      gap: theme.spacing(1),
      minWidth: 0,
      flex: 1,
    },
    leadingSlot: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: LEADING_SLOT_SIZE,
      height: LEADING_SLOT_SIZE,
      color: theme.palette.text.secondary,
    },
    textStack: {
      gap: theme.spacing(0.25),
      minWidth: 0,
      flex: 1,
    },
    titleRow: {
      alignItems: 'center',
      gap: theme.spacing(0.5),
      minWidth: 0,
    },
    title: {
      minWidth: 0,
    },
    trailing: {
      flexShrink: 0,
    },
  }),
);
